/**
 * Created by qiuleo on 16/11/15.
 */
module.exports = {
    host: 'https://h5.weidian.com',
    api : '//thor.weidian.com/',
    thorHost:'https://thor.weidian.com/'
};


/** WEBPACK FOOTER **
 ** ../config/mapping.config.js
 **/